import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {

  async login(username, password) {
    const newJson = { username, password };
    const response = await axios.post(API_URL + "/login", newJson, { headers: authHeader() })
    return response.data;
  },

  async getProfile() {
    const response = await axios.get(API_URL + "/me", { headers: authHeader() })
    return response.data;
  },

  async editProfile(profile) {
    profile.type = 'profile'
    const newJson = { stuff: profile };
    const response = await axios.patch(API_URL + "/me", newJson, { headers: authHeader() })
    return response.data;
  },

  async uploadPic(pic, userId) {
    const postUrl = API_URL + "/uploads/users/" + userId + "/profile-image";
    const response = await axios.post(postUrl,
      { attachment: pic },
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  }

}